(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("textile", [], factory);
	else if(typeof exports === 'object')
		exports["textile"] = factory();
	else
		root["textile"] = factory();
})(this, function() {
return 